<template>
    <div class="mt-3 bg-gray" v-if="all_followups.length > 0">
        <h4>Training follow-up</h4>
        <hr/>
        <div v-if="all_followups.length > 0">
            <div v-for="(trainee_followup, index) in all_followups" :key="index">
                <hr style="border: 1px solid #777171;">
                <div class="row">
                    <div v-if="trainee_followup.trade_use != null" class="col-md-6 col-sm-6 col-lg-4">
                        <div class="media text-muted">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1">3.1 Past Occupation</strong>
                                {{ trainee_followup.past_occupation ? trainee_followup.past_occupation.desc : ''}}
                            </p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-lg-4">
                        <div class="media text-muted">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1"><span>{{ trainee_followup.trade_use == null ?  '3.1' : '3.2' }}</span> Present Occupation</strong>
                                {{ trainee_followup.present_occupation ? trainee_followup.present_occupation.desc : '' }}
                            </p>
                        </div>
                    </div>

                    <div v-if="trainee_followup.trade_use != null" class="col-md-6 col-sm-6 col-lg-4">
                        <div class="media text-muted">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1">4.1 Past Monthly Income</strong>
                                {{ trainee_followup.current_family_monthly_expense }}
                            </p>
                        </div>
                    </div>
                    <div v-if="trainee_followup.trade_use != null" class="col-md-6 col-sm-6 col-lg-4">
                        <div class="media text-muted">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1">4.2 Present Monthly Income</strong>
                                {{ trainee_followup.present_monthly_income }}
                            </p>
                        </div>
                    </div>

                    <div v-if="trainee_followup.trade_use == null" class="col-md-6 col-sm-6 col-lg-4">
                        <div class="media text-muted">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1">4.1 Present Monthly Income</strong>
                                {{ trainee_followup.present_monthly_income }}
                            </p>
                        </div>
                    </div>
                    <div v-if="trainee_followup.trade_use == null" class="col-md-6 col-sm-6 col-lg-4">
                        <div class="media text-muted">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1">4.2a Family Monthly Income</strong>
                                {{ trainee_followup.family_monthly_income }}
                            </p>
                        </div>
                    </div>

                </div>
                <div class="row">
                    <div v-if="trainee_followup.trade_use == null" class="col-md-6 col-sm-6 col-lg-4">
                    <div class="media text-muted">
                      <p class="media-body pb-2 mb-0 medium lh-150">
                        <strong class="d-block text-dark pb-1">4.2b Income From Training Trade</strong>
                        {{ trainee_followup.income_from_training_trade }}
                      </p>
                    </div>
                  </div>
                    <div v-if="trainee_followup.trade_use != null" class="col-md-6 col-sm-6 col-lg-4">
                        <div class="media text-muted">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1">4.3 Family Monthly Income</strong>
                                {{ trainee_followup.family_monthly_income }}
                            </p>
                        </div>
                    </div>
                    <div v-if="trainee_followup.trade_use == null" class="col-md-6 col-sm-6 col-lg-4">
                        <div class="media text-muted">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1">4.3 Current Monthly Expenses of Family</strong>
                                {{ trainee_followup.current_family_monthly_expense }}
                            </p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-lg-4">
                        <div class="media text-muted">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1">Income Source</strong>
                                <span v-for="income_source in trainee_followup.income_sources" :key="income_source.id">
                                    {{ income_source.desc }} {{ index + 1 !== trainee_followup.income_sources.length ? " ," : "" }}
                                </span>
                            </p>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6 col-sm-6 col-lg-4">
                    <div class="media text-muted">
                      <p class="media-body pb-2 mb-0 medium lh-150">
                        <strong class="d-block text-dark pb-1">5. Training Trade</strong>
                        <span v-for="training_trade in trainee_followup.training_trades" :key="training_trade.id">
                                    {{ training_trade.desc }} {{ index + 1 !== trainee_followup.training_trades.length ? " ," : "" }}
                                </span>
                      </p>
                    </div>
                  </div>
                    <div class="col-md-6 col-sm-6 col-lg-4">
                        <div class="media text-muted">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1">6.1 Are You Jobholder?</strong>
                                <span v-if="trainee_followup.is_job_holder == 1">Yes</span>
                                <span v-if="trainee_followup.is_job_holder == 0">No</span>
                            </p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-lg-4">
                        <div class="media text-muted">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1">Job Description</strong>
                                {{ trainee_followup.job_description }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 col-sm-6 col-lg-4">
                    <div class="media text-muted">
                      <p class="media-body pb-2 mb-0 medium lh-150">
                        <strong class="d-block text-dark pb-1">6.2 Any Business?</strong>
                        <span v-if="trainee_followup.doing_business == 1">Yes</span>
                        <span v-if="trainee_followup.doing_business == 0">No</span>
                      </p>
                    </div>
                  </div>
                    <div class="col-md-6 col-sm-6 col-lg-4">
                        <div class="media text-muted">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1">6.3 Business Types</strong>
                                <span v-for="business_type in trainee_followup.business_types" :key="business_type.id">
                                    {{ business_type.desc }} <br>
                                </span>
                            </p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-lg-4">
                        <div class="media text-muted">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1">7. Money Source</strong>
                                <span v-for="money_source in trainee_followup.money_sources" :key="money_source.id">
                                    {{ money_source.desc }} <br>
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 col-sm-6 col-lg-4">
                    <div class="media text-muted">
                      <p class="media-body pb-2 mb-0 medium lh-150">
                        <strong class="d-block text-dark pb-1">8. Businesses</strong>
                        <span v-for="business in trainee_followup.businesses" :key="business.id">
                                    {{ business.desc }} <br>
                                </span>
                      </p>
                    </div>
                  </div>
                    <div class="col-md-6 col-sm-6 col-lg-4">
                        <div class="media text-muted">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1">9. Someone else has seen inspired you</strong>
                                {{ trainee_followup.is_inspire }}
                            </p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-lg-4">
                        <div class="media text-muted">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1">10. Are you receiving any service from the government office? </strong>
                                <span v-if="trainee_followup.govt_help == 1">Yes</span>
                                <span v-if="trainee_followup.govt_help == 0">No</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6 col-sm-6 col-lg-4">
                    <div class="media text-muted">
                      <p class="media-body pb-2 mb-0 medium lh-150">
                        <strong class="d-block text-dark pb-1">Govt Help Description</strong>
                        {{ trainee_followup.govt_help_description }}
                      </p>
                    </div>
                  </div>
                    <div class="col-md-6 col-sm-6 col-lg-4">
                        <div class="media text-muted">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1">11. Has there been any benefit to using advanced technology?</strong>
                                <span v-if="trainee_followup.is_technology_use == 0">Too much</span>
                                <span v-if="trainee_followup.is_technology_use == 1">More</span>
                                <span v-if="trainee_followup.is_technology_use == 2">Roughly</span>
                                <span v-if="trainee_followup.is_technology_use == 3">No</span>
                            </p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-lg-4">
                        <div class="media text-muted">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1">12. How much have you benefited financially from training?  </strong>
                                <span v-if="trainee_followup.is_financially_improvement == 0">Too much</span>
                                <span v-if="trainee_followup.is_financially_improvement == 1">More</span>
                                <span v-if="trainee_followup.is_financially_improvement == 2">Roughly</span>
                                <span v-if="trainee_followup.is_financially_improvement == 3">No</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="row">
<!--                    <div class="col-md-6 col-sm-6 col-lg-4">-->
<!--                        <div class="media text-muted">-->
<!--                            <p class="media-body pb-2 mb-0 medium lh-150">-->
<!--                                <strong class="d-block text-dark pb-1">Survey Conducted By</strong>-->
<!--                                {{ trainee_followup.survey_conducted.name }}-->
<!--                            </p>-->
<!--                        </div>-->
<!--                    </div>-->
                  <div class="col-md-6 col-sm-6 col-lg-4">
                    <div class="media text-muted">
                      <p class="media-body pb-2 mb-0 medium lh-150">
                        <strong class="d-block text-dark pb-1">13. At present, your social status has increased?</strong>
                        <span v-if="trainee_followup.is_society_respect == 0">Too much</span>
                        <span v-if="trainee_followup.is_society_respect == 1">More</span>
                        <span v-if="trainee_followup.is_society_respect == 2">Roughly</span>
                        <span v-if="trainee_followup.is_society_respect == 3">No</span>
                      </p>
                    </div>
                  </div>
                    <div class="col-md-6 col-sm-6 col-lg-4">
                        <div class="media text-muted">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1">Survey Date </strong>
                                {{ trainee_followup.survey_conducted_date }}
                            </p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-lg-4">
                        <div class="media text-muted">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1">Information Provided By</strong>
                                {{ trainee_followup.survey_providers_by }}
                            </p>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-lg-4">
                        <div class="media text-muted">
                            <p class="media-body pb-2 mb-0 medium lh-150">
                                <strong class="d-block text-dark pb-1">Information Provided Date </strong>
                                {{ trainee_followup.survey_providers_date }}
                            </p>
                        </div>
                    </div>
                </div>
              <div class="row">
                <div class="col-md-6 col-sm-6 col-lg-4">
                  <div class="media text-muted">
                    <p class="media-body pb-2 mb-0 medium lh-150">
                      <strong class="d-block text-dark pb-1">Information Provided Date </strong>
                      {{ trainee_followup.survey_providers_date }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
    import http from "@state/http";

    export default {
        props: ["trainee_id"],
        components: { },
        data() {
            return {
                flag: false,
                all_followups: [],
            };
        },


        mounted() {
            this.getTraineeFollowup();
        },
        methods: {
            async getTraineeFollowup() {
                await http.get("api/followup/list/" + this.trainee_id)
                    .then(resource => {
                        this.all_followups = resource.data.all_followups
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
        },
    };
</script>

<style scoped>

</style>
